/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const H4 = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <h4 {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </h4>
  );
};

H4.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default H4;
